export default __webpack_public_path__ + "static/media/social-logo.9157e6bd.svg";